import styled from '@emotion/styled'

export const Heading = styled.h1`
  margin: 0 0 1em;
  text-align: center;
  font-size: 1.6em;
  font-weight: 600;
`

export const Message = styled.p`
  text-align: center;
`